import { createWorkflowActions } from '@tock/shared/workflow/actionCreators';
import AppConstants from 'constants/AppConstants';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

export function getStripePaymentsReport(fileToUpload: File, reportType: string): ApiAction {
  return {
    TockApi: {
      postFile: `/finance/stripe/payments/csv-transform?reportType=${reportType}`,
      request: fileToUpload,
      type: AppConstants.FINANCE_STRIPE_PAYMENTS_REPORT,
    },
  };
}

export const {
  fetchWorkflowStatus: generateReportStatus,
  fetchWorkflowResult: generateReportResult,
} = createWorkflowActions({
  statusType: ClowncarAppConstants.NULL,
  resultType: ClowncarAppConstants.NULL,
  errorType: ClowncarAppConstants.NULL,
});
